// @ts-strict-ignore
import React, {
  useContext,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  AggregationEditorContext,
  AggregationsSubEditorContainer,
} from 'flow/editor/components/aggregations';
import { RuleBuilderContext } from '../../context';
import { ThresholdContext } from './context';
import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';
import { resetSubEditor } from 'flow/store/redux/thunks';
import type { AggregationSourceData } from 'flow/editor/components/aggregations/types';
import {
  aggregationComponentsToSourceData,
} from 'flow/editor/components/aggregations/transformers';
import { selectRuleBuilderActiveSubEditor } from 'flow/store/redux/selectors';
import { RuleBuilderSubEditorSide } from 'flow/store/engine/types/utils';
import { AggregationEditorOrigin } from 'flow/editor/components/NodeEditorDrawer/types';

const AggregationsWrapper = () => {
  const dispatch = useAppDispatch();
  const { populatedThreshold } = useContext(ThresholdContext);
  const { keyboardFocus } = useContext(RuleBuilderContext);
  const activeSubEditor = useAppSelector(selectRuleBuilderActiveSubEditor);

  // Derive origin from the active sub-editor side (LHS or RHS of the threshold)
  const origin = activeSubEditor.side === RuleBuilderSubEditorSide.LHS
    ? AggregationEditorOrigin.THRESHOLD_LEFT
    : AggregationEditorOrigin.THRESHOLD_RIGHT;

  // Read persisted aggregation components from the correct threshold side
  const side = origin === AggregationEditorOrigin.THRESHOLD_LEFT ? 'left' : 'right';
  const { aggregationComponents } = populatedThreshold[side];

  const aggregationEditorContainerRef = useRef<HTMLDivElement>(null);
  const [aggregationContextSourceData, setAggregationContextSourceData] = useState<
  AggregationSourceData
  >(() => aggregationComponentsToSourceData(aggregationComponents));

  const aggregationEditorContext = useMemo(() => ({
    sourceData: aggregationContextSourceData,
    setSourceData: setAggregationContextSourceData,
    handleClose: () => {
      dispatch(resetSubEditor());
      keyboardFocus.enable();
    },
    aggregationEditorContainerRef,
    origin,
  }), [dispatch, keyboardFocus, aggregationContextSourceData, origin]);

  return (
    <AggregationEditorContext.Provider value={aggregationEditorContext}>
      <AggregationsSubEditorContainer data={{ threshold: populatedThreshold }} />
    </AggregationEditorContext.Provider>
  );
};

export default AggregationsWrapper;
